module.exports = __webpack_public_path__ + "fonts/grotasansrounded-regular-webfont.829c6520.otf";